export const SUPER_ADMIN_PERMISSIONS = [
  'dashboard.read',
  'content.manage',
  'card.read',
  'card.manage',
  'card.delete',
  'user.read',
  'admin.manage'
]

export function hasAdminPermission(user, permission) {
  if (!user) return false
  if (user.isSuperAdmin) return true
  return Array.isArray(user.permissions) && user.permissions.indexOf(permission) !== -1
}

export function permissionsForAdmin(user) {
  if (!user) return []
  return user.isSuperAdmin
    ? SUPER_ADMIN_PERMISSIONS.slice()
    : (Array.isArray(user.permissions) ? user.permissions : [])
}
